import React from 'react'

import loader from './rings.svg'
import './loader.scss'

export default function Loader ({ children }) {
    return (
        <div className='loading__container'>
            <div className='loading'>
                <div className='loadingText'>{ children || `Loading automotive intelligence systems...` }</div>
                <img src={ loader } alt='Loading...' />
            </div>
        </div>
    )
}